module.exports = "/packs/images/svg/ireland/facilities/badminton_court~4b84be92dda489d81b2d3e02de4a3160.svg";